import { createContext } from 'react'

export const UCContext = createContext(null)
